<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 10C16.8807 10 18 11.1193 18 12.5V15.5C18 16.8807 16.8807 18 15.5 18H2.5C1.11929 18 0 16.8807 0 15.5V12.5C0 11.1193 1.11929 10 2.5 10H15.5Z"
    />
    <path
      d="M15.5 0C16.8807 6.44256e-08 18 1.11929 18 2.5V5.5C18 6.88071 16.8807 8 15.5 8H2.5C1.11929 8 0 6.88071 0 5.5V2.5C0 1.11929 1.11929 6.44256e-08 2.5 0H15.5Z"
    />
  </svg>
  <!-- fill="rgb(var(--v-theme-primary)) -->
</template>
